import { createSmartDocPillBuilder } from 'owa-mail-smart-doc';
import { createSmartReplyPillBuilder } from 'owa-mail-smart-reply';
import { createSmartTimePillBuilder } from 'owa-mail-smart-time';
import { ClientItem } from 'owa-mail-store';
import { SmartPillBuilder } from 'owa-smart-pill';

export default function registerSmartPillBuilders(item: ClientItem): SmartPillBuilder[] {
    // Arbitrator handles flight checking
    return [
        createSmartTimePillBuilder(item),
        createSmartDocPillBuilder(item),
        createSmartReplyPillBuilder(item),
    ];
}
